// Monarch application routing
export enum AppPath {
	Home = '/',
	Index = '/',
	Reward = '/rewards/{id}',
	Rewards = '/rewards',
	NotFound = '/404',
	AdminDashboard = '/admin/dashboard',
	AdminRewardsCatalog = '/admin/rewards/catalog',
	Bookmark = '/bookmark',
	OneOnOnes = '/one-on-ones',
	Feedback = '/feedback',
	ManagerEnablement = '/manager-enablement',
	PerformanceRecap = '/growth/recap-review',
	Profile = '/company/users/{id}',
}

// Monolith application routing
export enum Route {
	AdminAwards = '/admin/awards',
	AdminBilling = '/company/billing',
	AdminBonusReports = 'company/bonus_reports',
	AdminBillingActivity = '/company/billing_activity',
	AdminConfigurations = 'company/settings/configuration/edit',
	AdminEarnings = '/company/accounts',
	AdminGiving = 'company/reports/giving',
	AdminImportedUsers = '/company/imported_users',
	AdminItems = '/company/catalog_items',
	AdminParticipation = '/company/users/participation',
	AdminRecognition = '/company/reports/bonuses',
	AdminRewards = '/company/rewards?aasm_state=approved&range=all',
	AdminSecurity = '/admin/security/sign_in_logs',
	AdminChanges = '/admin/security/data_change_logs',
	AdminCompanyChanges = '/admin/security/data_change_logs/company',
	AdminSettings = '/company/settings/appearance/edit',
	AdminSpend = '/analytics/budget_utilization',
	AdminTotals = '/company/rewards/totals_report',
	AdminUsers = '/company/users',

	Awards = '/claimable_awards',
	Billing = '/company/billing',
	Hashtags = '/company/hashtags/{id}',
	Home = '/bonuses',
	Bonuses = '/bonuses/{id}',
	Integrations = '/company/settings/integrations',
	HRISIntegrations = '/company/settings/integrations#user-management',
	Login = '/users/sign_in_start',
	Logout = '/users/sign_out',
	MyRewards = '/company/rewards/my_rewards',
	PendingAwards = '/awards/approval_requests',
	Rewards = '/company/rewards/new',
	Settings = '/users/edit',
	UserProfile = '/company/users/{id}',
}

// External pages
export enum Page {
	Contact = 'https://bonus.ly/contact',
	Help = 'https://help.bonus.ly/en/',
	NewFeatures = 'https://help.bonus.ly/en/articles/4076250-product-updates-and-new-features',
	PrivacyPolicy = 'https://bonus.ly/privacy_policy',
	Status = 'https://status.bonus.ly/',
	TermsOfService = 'https://bonus.ly/terms_of_service',
	ExtendTrial = 'https://go.bonus.ly/talk-to-a-specialist',
}
